import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authentication/authentication.slice';
import forgotPasswordReducer from './forgotPassword/forgotPassword.slice';
import deviceVerificationReducer from './deviceVerification/deviceVerification.slice';
import sidebarReducer from '../entities/sidebar/store/slice';
import { authApi } from './authentication/authentication.actions';
import { sidebarApi } from '../entities/sidebar/store/actions';
import { reportsApi } from './reports/reports.actions';

import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    forgotPassword: forgotPasswordReducer,
    deviceVerification: deviceVerificationReducer,
    [authApi.reducerPath]: authApi.reducer,
    sidebar: sidebarReducer,
    [sidebarApi.reducerPath]: sidebarApi.reducer,
    [reportsApi.reducerPath]: reportsApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(
    authApi.middleware,
    sidebarApi.middleware, 
    reportsApi.middleware
  ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
